import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalPaymentInstallmentComponent } from '@app/shared/components/modals/modal-payment-installment/modal-payment-installment.component';
import { SvgModule } from '@app/shared/components/svg/svg.module';

import { MatDialogModule } from '@angular/material/dialog';
import { ModalFacilipayOneyComponent } from './modal-facilipay-oney/modal-facilipay-oney.component';
import { SvgCartModule } from '@app/shared/components/svg/cart/svg-cart.module';
import { RefModule } from '@app/shared/components/ref/ref.module';

@NgModule({
  imports: [CommonModule, MatDialogModule, SvgModule, SvgCartModule, RefModule],
  declarations: [ModalPaymentInstallmentComponent, ModalFacilipayOneyComponent],
  exports: [ModalPaymentInstallmentComponent]
})
export class ModalPaymentInstallmentModule {}
